import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/EXPORT_CSV';
export const {action: show} = createAction(`${domain}/SHOW`, (institutionId, csvType) => ({institutionId, csvType}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: clearCSVLink} = createAction(`${domain}/CLEAR_CSV_LINK`, () => ({}));

export const {
    action: getCSVLink,
    success: getCSVLinkSuccess,
    failed: getCSVLinkFailed,
} = createAction(
    `${domain}/GET_CSV_LINK`,
    (institutionId, csvType, from, to) => ({institutionId, csvType, from, to}),
    csv => ({csv}),
);
